import { render } from "./TableDiagnostico.vue?vue&type=template&id=13a95598"
import script from "./TableDiagnostico.vue?vue&type=script&lang=js"
export * from "./TableDiagnostico.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__